import { useCallback, useEffect, useState } from 'react';
/**
 * Fetches the account's configured break types (active only). Both clock-out
 * modals previously fell back to a hardcoded Lunch/Rest/Personal/Other list
 * regardless of what the account configured — and `is_paid` on the real types
 * drives net-hours/pay math, so the configured list must be the one offered.
 *
 * Returns null until loaded (callers keep their defaults as the fallback).
 */
export function useBreakTypes(client, accountId) {
    const [breakTypes, setBreakTypes] = useState(null);
    const refresh = useCallback(async () => {
        if (!accountId) {
            setBreakTypes(null);
            return;
        }
        try {
            const res = await client.get(`/accounts/${accountId}/break-types`);
            const data = res && (res.success === undefined || res.success) ? res.data : null;
            if (Array.isArray(data)) {
                const active = data.filter((bt) => bt.is_active !== false);
                setBreakTypes(active.length > 0 ? active : null);
            }
            else {
                setBreakTypes(null);
            }
        }
        catch {
            setBreakTypes(null);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [accountId]);
    useEffect(() => {
        refresh();
    }, [refresh]);
    return { breakTypes, refresh };
}
